/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserCouponInfoRespVo } from './UserCouponInfoRespVo';
import {
    UserCouponInfoRespVoFromJSON,
    UserCouponInfoRespVoFromJSONTyped,
    UserCouponInfoRespVoToJSON,
    UserCouponInfoRespVoToJSONTyped,
} from './UserCouponInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataUserCouponInfoRespVo
 */
export interface PageDataUserCouponInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserCouponInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserCouponInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserCouponInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserCouponInfoRespVo>}
     * @memberof PageDataUserCouponInfoRespVo
     */
    records?: Array<UserCouponInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataUserCouponInfoRespVo interface.
 */
export function instanceOfPageDataUserCouponInfoRespVo(value: object): value is PageDataUserCouponInfoRespVo {
    return true;
}

export function PageDataUserCouponInfoRespVoFromJSON(json: any): PageDataUserCouponInfoRespVo {
    return PageDataUserCouponInfoRespVoFromJSONTyped(json, false);
}

export function PageDataUserCouponInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserCouponInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserCouponInfoRespVoFromJSON)),
    };
}

export function PageDataUserCouponInfoRespVoToJSON(json: any): PageDataUserCouponInfoRespVo {
    return PageDataUserCouponInfoRespVoToJSONTyped(json, false);
}

export function PageDataUserCouponInfoRespVoToJSONTyped(value?: PageDataUserCouponInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserCouponInfoRespVoToJSON)),
    };
}

